import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 0px;
  font-family: Gilroy;
  z-index: 10;
  width: 100%;
  margin-top: 64px; /* Position below navbar which is 64px height */

  @media screen and (min-width: 768px) {
    padding: 16px 0px;
    padding-left: 8vw;
    // max-width: 1016px;
    margin: 64px auto 0;
  }
`;

export const BreadcrumbItem = styled.span`
  font-size: 13px;
  font-weight: ${(props) => (!props.isActive ? "700" : "400")};
  color: white;
  cursor: ${(props) => (props.isActive ? "default" : "pointer")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "160px")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    text-decoration: ${(props) => (props.isActive ? "none" : "underline")};
  }

  @media screen and (min-width: 768px) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "240px")};
  }
`;

export const BreadcrumbSeparator = styled.div`
  display: flex;
  align-items: center;
  margin: 0 6px;
`;
